import { stylesParams } from '@wix/wix-vod-constants/app-settings';

export default stylesParams;
